



















import {
    Component,
    Prop,
    Vue,
    Emit,
    Watch,
} from 'vue-property-decorator';
import * as _ from 'lodash';

@Component({})
export default class BreadcrumbList extends Vue {

    get source() {
        return this.$route.matched;
    }

    private mounted() {
    }

}
